var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { query } from 'lit/decorators.js';
import { SdsInputBase } from '../_sds-input-base';
import styles from '../date/sds-input-date.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-input-time` is a web component input field for selecting and displaying time values.
 * It provides a user-friendly interface for entering time in a specific format.
 *
 * @tag sds-input-time
 */
let SdsInputTime = (() => {
    var _SdsInputTime__input_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-input-time')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsInputBase;
    let __input_decorators;
    let __input_initializers = [];
    let __input_extraInitializers = [];
    var SdsInputTime = _classThis = class extends _classSuper {
        get _input() { return __classPrivateFieldGet(this, _SdsInputTime__input_accessor_storage, "f"); }
        set _input(value) { __classPrivateFieldSet(this, _SdsInputTime__input_accessor_storage, value, "f"); }
        getInput() {
            return this._input;
        }
        render() {
            return html `
            <div class="${this.getClasses()}">
                <div class="sds-input__wrapper">
                    ${this.renderInput('text')} ${this.renderActionContainer()} ${this.renderTime()}
                </div>

                ${this.renderMessages()}
            </div>
        `;
        }
        renderTime() {
            return html `
            <sds-icon
                class="sds-input__calendar-icon"
                name="time"
                size="24"
                @click="${() => this.handleFocus()}"
            ></sds-icon>
        `;
        }
        emptyValue() {
            return '';
        }
        convertValue(value) {
            return value;
        }
        handleClear(event) {
            this.dispatchEvent(new CustomEvent(SdsInputBase.CHANGE_EVENT, { detail: { value: null } }));
            super.handleClear();
            event.stopPropagation();
        }
        constructor() {
            super(...arguments);
            _SdsInputTime__input_accessor_storage.set(this, __runInitializers(this, __input_initializers, void 0));
            __runInitializers(this, __input_extraInitializers);
        }
    };
    _SdsInputTime__input_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInputTime");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __input_decorators = [query('input.sds-input__element')];
        __esDecorate(_classThis, null, __input_decorators, { kind: "accessor", name: "_input", static: false, private: false, access: { has: obj => "_input" in obj, get: obj => obj._input, set: (obj, value) => { obj._input = value; } }, metadata: _metadata }, __input_initializers, __input_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInputTime = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInputTime = _classThis;
})();
export { SdsInputTime };
